import { Box, Paper, Stack } from '@mui/material';
import HistoryTable from './HistoryTable';

export default function History() {
    return (
        <Box sx={{ height: '100%', p: 0 }}>
            <Stack direction="column" height="100%">
                <Paper sx={{ overflow: 'auto', flex: 1 }}>
                    <HistoryTable />
                </Paper>
            </Stack>
        </Box>
    );
}
